import React, {useState} from 'react'
import {CopyContainer} from './style'
import {Icon} from 'components/Icons'
import { useScrollPosition } from "shared/Hooks/useScrollPosition"

export const Copyrights = ({light,active})=>{
    const [blackOnScroll, setBlackOnScroll] = useState(false)
    const isBrowser = typeof window !== `undefined`
    useScrollPosition(({prevPos,currPos}) => {
        if(isBrowser) {
            if(currPos.y < -61 && window.location.pathname !== '/kontakt') {
                setBlackOnScroll(true)
            }else {
                setBlackOnScroll(false)
            }
        }
    }, [blackOnScroll], false, false, 1000)
    return (
       <CopyContainer light={light || blackOnScroll} active={active}>
        Realizacja witryny: 
        <Icon type='ivLogo' color={(light || blackOnScroll)&&!active?'black':'white'} width={'80px'}/>
       </CopyContainer>
    )
}